import { type ReactNode } from 'react';
import { tv } from 'tailwind-variants';

const row = tv({
  base: 'flex min-w-0 w-full max-w-full flex-wrap items-center justify-end gap-2',
});

export interface ScreenContentActionsProps {
  readonly children: ReactNode;
  readonly className?: string;
  readonly testId?: string;
}

/**
 * Canonical XY band for page-scoped secondary actions (especially Obnovit).
 * Mount via `ListPageLayout.contentActions` (after KPIs) or the same relative
 * spot on non-list hubs — never in `EnterprisePageHeader`.
 */
export function ScreenContentActions({
  children,
  className,
  testId = 'screen-content-actions',
}: ScreenContentActionsProps): JSX.Element {
  return (
    <div className={row({ className })} data-testid={testId}>
      {children}
    </div>
  );
}
